import RpcClass from "../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.healthcheck.CalApi';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class CalApi extends RpcClass{

    /**
     *  @class CalApi
     *  @alias module:src/server/com/silkplm/rpc/healthcheck/CalApi.CalApi
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     addBusinessEntity() {
            return RpcClass.rpcCall('/rpc/healthcheck/cal-api/add-business-entity', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteBusinessEntity() {
            return RpcClass.rpcCall('/rpc/healthcheck/cal-api/delete-business-entity', []);
    }
    /** 
     * @async
     * @param e {Date} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Date>}
     */
     getEchoDate(e) {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/healthcheck/cal-api/get-echo-date', [e]);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                            if(rawValue instanceof Date || rawValue === null || rawValue === undefined){ 
            v = rawValue; 
        } else if(typeof rawValue === 'string' || rawValue instanceof String){ 
            if(rawValue.match(/^\d+$/)){ 
                v = new Date(Number(rawValue)); 
            } else { 
                v = new Date(rawValue); 
            } 
        } else if (typeof rawValue === "number") { 
            v = new Date(rawValue); 
        } else if(rawValue instanceof moment) { 
            v = rawValue.toDate(); 
        } else { 
            v = rawValue; 
        }         

                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @param e {Date} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Date>}
     */
     getEchoInstant(e) {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/healthcheck/cal-api/get-echo-instant', [e]);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                    v = new Date(rawValue)
                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @param e {LocalDate} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<LocalDate>}
     */
     getEchoLocalDate(e) {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/healthcheck/cal-api/get-echo-local-date', [e]);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                    v = new LocalDate(); v.value = rawValue;
                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @param e {LocalDateTime} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<LocalDateTime>}
     */
     getEchoLocalDateTime(e) {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/healthcheck/cal-api/get-echo-local-date-time', [e]);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                    v = new LocalDateTime(); v.value = rawValue;
                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @param e {LocalTime} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<LocalTime>}
     */
     getEchoLocalTime(e) {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/healthcheck/cal-api/get-echo-local-time', [e]);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                    v = new LocalTime(); v.value = rawValue;
                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/healthcheck/Cal.Cal>}
     */
     getNow() {
            return RpcClass.rpcCall('/rpc/healthcheck/cal-api/get-now', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Date>}
     */
     getNowAsDate() {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/healthcheck/cal-api/get-now-as-date', []);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                            if(rawValue instanceof Date || rawValue === null || rawValue === undefined){ 
            v = rawValue; 
        } else if(typeof rawValue === 'string' || rawValue instanceof String){ 
            if(rawValue.match(/^\d+$/)){ 
                v = new Date(Number(rawValue)); 
            } else { 
                v = new Date(rawValue); 
            } 
        } else if (typeof rawValue === "number") { 
            v = new Date(rawValue); 
        } else if(rawValue instanceof moment) { 
            v = rawValue.toDate(); 
        } else { 
            v = rawValue; 
        }         

                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @param cal {module:src/server/com/silkplm/model/healthcheck/Cal.Cal} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/healthcheck/Cal.Cal>}
     */
     saveInDb(cal) {
            return RpcClass.rpcCall('/rpc/healthcheck/cal-api/save-in-db', [cal]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     updateBusinessEntity() {
            return RpcClass.rpcCall('/rpc/healthcheck/cal-api/update-business-entity', []);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.healthcheck.CalApi';
metadata.__type_short__ = 'CalApi';
CalApi.prototype.__metadata__ = metadata;

CalApi.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/healthcheck/CalApi */
export default CalApi

export { CalApi }
